import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { GET_EVENTS } from '../graphql/queries.graphql';
import { EventsResponse, EventsSearchPayload } from '../../models/open-days.models';
import { map } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class OpenDaysApiService {
	constructor(private _apollo: Apollo) {}

	getEvents(args: EventsSearchPayload) {
		const product = args.product.toUpperCase();
		const formattedPayload = {
			...args,
			product,
		};

		return this._apollo
			.query<EventsResponse>({
				query: GET_EVENTS,
				variables: formattedPayload,
			})
			.pipe(map(({ data }) => data.events));
	}
}
